/**
 * 生徒テスト学習実施結果詳細取得API
 */
import { Component, Vue } from 'vue-property-decorator'
import {
  ApiResponseStudyResultDetails,
  ApiResponseStudyResultLastMinuteCheck,
  ApiResponseStudyResultResolve,
} from '@/models/apiResponses/studyResultDetails'
import { StudyResultDetailImage } from '@/models/studyResultDetailModel'

@Component
export default class StudentStudyResultDetailApi extends Vue {
  /**
   * 生徒テスト学習実施結果詳細取得
   * @param paperTestId 紙テスト結果ID
   * 生徒テスト学習実施結果
   */
  protected async getStudentStudyResultDetail(paperTestId: number): Promise<ApiResponseStudyResultDetails> {
    const { data }: { data: ApiResponseStudyResultDetails } = await Vue.prototype.$http.httpWithToken
      .get('/v2/student/study_results/paper_test_detail', { params: { paperTestId: paperTestId } })
      .catch(() => ({ data: null }))

    return data
  }

  /**
   * 生徒テスト直前チェック実施結果取得
   * @param curriculumSUnitId 小項目ID
   * @returns 生徒テスト直前チェック実施結果
   */
  protected async getStudentStudyResultLastMinuteCheck(
    curriculumSUnitId: number
  ): Promise<ApiResponseStudyResultLastMinuteCheck> {
    const { data }: { data: ApiResponseStudyResultLastMinuteCheck } = await Vue.prototype.$http.httpWithToken
      .get('/v2/student/study_results/last_minute_check', { params: { curriculumSUnitId: curriculumSUnitId } })
      .catch(() => ({ data: null }))

    return data
  }

  /**
   * 生徒テスト解きなおし実施結果取得
   * @param curriculumSUnitId 小項目ID
   * @returns 生徒テスト解きなおし実施結果
   */
  protected async getStudentStudyResultResolve(curriculumSUnitId: number): Promise<ApiResponseStudyResultResolve> {
    const { data }: { data: ApiResponseStudyResultResolve } = await Vue.prototype.$http.httpWithToken
      .get('/v2/student/study_results/study_result_resolve', { params: { curriculumSUnitId: curriculumSUnitId } })
      .catch(() => ({ data: null }))

    return data
  }

  /**
   * 生徒個別結果資料ダウンロード
   * @param year 実施年度
   * @param originalCurriculumId オリジナルカリキュラムID
   * @returns [生徒個別結果資料PDFデータ, ヘッダー情報]
   */
  protected async downloadStudentStudyResultPdf(
    year: number,
    originalCurriculumId: number
  ): Promise<[Blob, { [headerKey: string]: string }]> {
    const res = await Vue.prototype.$http.httpWithToken.get('/v2/student/study_results/download_pdf', {
      params: { year: year, originalCurriculumId: originalCurriculumId },
      responseType: 'blob',
      dataType: 'binary',
    })

    return [res.data, res.headers]
  }

  /**
   * 生徒テストキャプチャイメージurl取得
   * @param curriculumSUnitId 小項目ID
   * @param category カテゴリー
   * @returns 生徒テストキャプチャイメージurl
   */
  protected async getStudentStudyResultImageUrl(
    curriculumSUnitId: number,
    category: number
  ): Promise<StudyResultDetailImage[]> {
    const { data }: { data: StudyResultDetailImage[] } = await Vue.prototype.$http.httpWithToken
      .get('/v2/student/study_results/study_result_capture_url', {
        params: { curriculumSUnitId: curriculumSUnitId, category: category },
      })
      .catch(() => ({ data: null }))

    return data
  }
}
